import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReplyBoxField from 'components/ReplyBoxField';
import {
  buildContactGroup,
  buildSelectedChannelGroup,
} from 'services/template-tags';
import { GECKO_CONSTS, GECKO_UTILS, GeckoFields, GeckoField } from 'ui';
import './index.scss';
import { BotTagManagerField } from '../BotTagManager';
import { connect } from 'react-redux';

const buildTemplateContext = () => {
  return [
    buildContactGroup(),
    buildSelectedChannelGroup({
      channel: null,
      showChannelQueuePosition: true,
    }),
  ];
};

class ChatFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editting: {},
    };
  }

  render() {
    return (
      <div className="SkillDataCapture-ChatFields">
        {this.props.value.map((rawField) => {
          const field = this.props.fields.find(
            (field) => field.id === rawField.field_id
          );
          const isEditting = this.state.editting[field.id];
          const toggleEditting = () => {
            const editting = Object.assign({}, this.state.editting, {
              [field.id]: !isEditting,
            });
            this.setState({ editting });
          };
          const changeHandler = (message) => {
            const newField = Object.assign({}, rawField, { message });
            const newFields = this.props.value.map((oldField) => {
              if (oldField.field_id !== rawField.field_id) {
                return oldField;
              }
              return newField;
            });
            this.props.onChange(newFields);
          };
          const iconClassMapType = {
            email: 'far fa-at',
            telephone: 'far fa-phone',
            text: 'far fa-align-left',
            textarea: 'far fa-align-left',
            date: 'far fa-calendar-alt',
          };
          const iconClassMapKey = {
            first_name: 'far fa-user',
            last_name: 'far fa-user',
          };
          return (
            <div key={field.id} className="SkillDataCapture-ChatFields-field">
              <div
                className="SkillDataCapture-ChatFields-field-display"
                onClick={toggleEditting}
              >
                <div className="SkillDataCapture-ChatFields-field-typeicon">
                  <i
                    className={
                      iconClassMapKey[field.key] ||
                      iconClassMapType[field.type] ||
                      'fal fa-info'
                    }
                  ></i>
                </div>
                <div className="SkillDataCapture-ChatFields-field-label">
                  {field.label}
                </div>
                {isEditting ? (
                  <div className="SkillDataCapture-ChatFields-field-closeicon">
                    <i className="far fa-angle-up"></i>
                  </div>
                ) : (
                  <div className="SkillDataCapture-ChatFields-field-editicon">
                    <i className="far fa-edit"></i>
                  </div>
                )}
              </div>
              {isEditting ? (
                <div className="SkillDataCapture-ChatFields-field-edit">
                  <ReplyBoxField
                    value={rawField.message}
                    onChange={changeHandler}
                    templateContext={buildTemplateContext()}
                    compileTemplateTags={false}
                    meta={{ mail_merge: { show: true } }}
                  />
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }
}

class ChatFieldsSelector extends Component {
  static propTypes = {
    fields: PropTypes.arrayOf(PropTypes.object),
    value: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func,
  };

  static defaultProps = {
    fields: [],
    value: [],
    onChange: () => {},
  };

  field() {
    const options = this.props.fields
      .filter((field) => field.type !== 'display')
      .map((field) => {
        return {
          label: field.label,
          value: field.id,
        };
      });
    return {
      key: 'value',
      type: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
      options: options,
    };
  }

  handleChange(_key, value) {
    const newValue = value.map((fieldId) => {
      const currentField = this.props.value.find(
        (rawField) => rawField.id === fieldId
      );
      if (currentField) {
        return currentField;
      }
      const field = this.props.fields.find((field) => field.id === fieldId);
      return { field_id: fieldId, message: `What is your ${field.label}?` };
    });
    return this.props.onChange(newValue);
  }

  render() {
    const value = this.props.value.map((rawField) => {
      return rawField.field_id;
    });
    return (
      <div className="SkillDataCapture-ChatFieldsSelector">
        <GeckoField
          values={{ value }}
          field={this.field()}
          handler={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

class SkillDataCapture extends Component {
  static propTypes = {
    value: PropTypes.shape({
      name: PropTypes.string,
      internal_skill: 'DATA_CAPTURE',
      config: PropTypes.shape({
        confirm_message: PropTypes.string,
        outro_message: PropTypes.string,
        fields: PropTypes.arrayOf(PropTypes.object),
      }),
    }),
    onChange: PropTypes.func,
  };
  static defaultProps = {
    value: {
      name: null,
      internal_skill: 'DATA_CAPTURE',
      config: {
        confirm_message: `I'll just need to grab a few details from you in order to progress.  During this time you won't be able to ask me anything else, do you want to continue?`,
        outro_message: `Great!  Thanks for providing me with those.`,
        fields: [],
      },
    },
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = { addingField: false };
  }

  geckoFields() {
    return [
      {
        key: '',
        label: 'Configure the Data Capture Skill',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        width: '100%',
        className: 'BotTabEditContainer-section-heading',
        component: <div style={{ display: 'none' }}></div>,
      },
      {
        key: 'name',
        label: 'Skill Title',
        required: true,
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      },
      {
        key: 'bot_tag_ids',
        label: 'Skill Tags',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        width: '100%',
        component: <BotTagManagerField item={this.props.value} />,
      },
      {
        key: 'config.confirm_message',
        label: 'Confirm message',
        required: true,
        description:
          'A confirmation message that will allow the user to confirm they want to continue.  They will get the options for Yes and No.',
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: (
          <ReplyBoxField
            templateContext={buildTemplateContext()}
            compileTemplateTags={false}
            meta={{ mail_merge: { show: true } }}
          />
        ),
      },
      {
        key: 'config.outro_message',
        label: 'Exit message',
        required: true,
        description: 'A message to wrap up the skill and let the user know.',
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: (
          <ReplyBoxField
            templateContext={buildTemplateContext()}
            compileTemplateTags={false}
            meta={{ mail_merge: { show: true } }}
          />
        ),
      },
      {
        key: 'config.fields',
        label: 'Choose which fields to ask for',
        required: true,
        description:
          'The fields will be asked for in the order they appear in this list.',
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: <ChatFieldsSelector fields={this.props.fields} />,
      },
      {
        key: 'config.fields',
        label: 'Configure fields',
        description:
          'Configure a custom question to be used when asking for the field.',
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        hideWhen: () =>
          !this.props.value ||
          !this.props.value.config.fields ||
          !this.props.value.config.fields.length,
        component: <ChatFields fields={this.props.fields} />,
      },
    ];
  }

  startAddingField() {
    this.setState({ addingField: true });
  }

  addField(_key, field) {
    const fields = this.props.value.config.fields.concat({
      field_id: field.id,
      message: `What is your ${field.label}?`,
    });
    const config = Object.assign({}, this.props.value.config, { fields });
    const skill = Object.assign({}, this.props.value, { config });
    this.props.onChange(skill);
    this.setState({ addingField: false });
  }

  fieldSelect() {
    const currentFieldIds = this.props.value.config.fields.map(
      (field) => field.field_id
    );
    const allowedFields = this.props.fields.filter(
      (field) => !currentFieldIds.includes(field.id)
    );
    return {
      key: 'key',
      type: GECKO_CONSTS.FIELD_TYPE_SELECT,
      options: allowedFields.map((field) => {
        return {
          label: field.label,
          value: field,
        };
      }),
      config: {
        autoFocus: true,
        openOnFocus: true,
      },
    };
  }

  handler(key, value) {
    const skill = GECKO_UTILS.setNestedValue(this.props.value, key, value);
    this.props.onChange(skill);
  }

  render() {
    return (
      <div className="SkillDataCapture">
        <GeckoFields
          values={this.props.value}
          fields={this.geckoFields()}
          handler={this.handler.bind(this)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    fields: state.fields,
  };
};

export default connect(mapStateToProps)(SkillDataCapture);
